// @comfy/shared — 最近生成列表逻辑
// 依据 Requirement 8.5：本地维护最近生成记录，按时间倒序展示，
// 默认上限 MAX_RECENT（20）张，每条保留提示词与生成参数。
// 纯函数实现：不修改输入，返回新数组。
import { MAX_RECENT } from "./types.js";
/**
 * 将一条新的最近生成记录插入到列表中。
 *
 * 行为：
 * - 不修改传入的 `list`（纯函数，返回新数组）。
 * - 合并后按 `createdAt` 倒序（最新在前）排序。
 * - 裁剪至 `MAX_RECENT`（20）条。
 * - 每条记录原样保留提示词（`prompt`）与生成参数（`params`）。
 *
 * @param list  现有最近生成记录列表。
 * @param entry 要插入的新记录。
 * @returns     插入并裁剪后的新列表（最多 MAX_RECENT 条，按时间倒序）。
 */
export function insertRecent(list, entry) {
    return [...list, entry]
        .slice()
        .sort((a, b) => b.createdAt - a.createdAt)
        .slice(0, MAX_RECENT);
}
//# sourceMappingURL=recent.js.map